// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';

import { withStyles } from '@material-ui/core/styles';
import {
  Loader,
  Voucher,
} from '../../../../../../../../components';


import styles from './styles';


class RecentVouchersContainer extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    loading: PropTypes.bool,
    vouchers: PropTypes.array,
  };

  static defaultProps = {
    classes: {},
    loading: false,
    vouchers: [],
  };

  render() {
    const {
      classes,
      loading,
      vouchers,
    } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.titleContainer}>
          <div className={classes.line} />
          <h5 className={classes.titleText}>Recent customers</h5>
          <div className={classes.line} />
        </div>
        {loading
          ? (
            <div className={classes.loaderContainer}>
              <Loader />
            </div>
          ) : (
            Array.from(vouchers).map(voucher => (
              <Voucher
                key={uuidv4()}
                voucher={voucher}
              />
            ))
          )}
      </div>
    );
  }
}

export default (withStyles(styles)(RecentVouchersContainer));
